import { requestAuthorized } from './index';
import { webApiEndpoint } from '../clientConfig';

export const fetchAddressBookEntries = () =>
  requestAuthorized({
    url: `${webApiEndpoint}/api/addressbook/entries`,
    method: 'get',
  }).then((response) => response.data && response.data);
